import type {
  ObjectToolbarConfig,
  RegisterToolbarConfigArgs,
} from '@/blocks/object-toolbar';

/**
 * Assemble the object-toolbar config for the Requests (change-request)
 * register/list page (CUS-136). Register toolbars are type-level: no
 * `parentObject` (permissions resolve against the type) and no `save` (a list
 * page has no form).
 *
 * Unlike most registers, the Requests page never surfaced an `ExportButton` and
 * has no create action — change requests are system-generated, not authored in
 * the register — so the toolbar carries only the relocated "Edit Filters" opener
 * (bridged up from the page's `CustomisableRibbon` in relocate mode) plus the
 * auto-injected Toolbar settings action. The shared
 * {@link RegisterToolbarConfigArgs} still requires `exportOptions`, but this
 * register has none, so the field is intentionally unused here.
 *
 * Pure so it can be unit-tested without rendering the page.
 */
export const buildRequestsRegisterToolbarConfig = ({
  title,
  counter,
  editRibbon,
}: RegisterToolbarConfigArgs): ObjectToolbarConfig => ({
  header: { title, counter },
  actions: {
    ...(editRibbon
      ? {
          overflow: [
            {
              id: 'edit',
              label: editRibbon.groupLabel,
              actions: [
                {
                  id: 'edit-ribbon',
                  label: editRibbon.label,
                  iconName: 'filter-lines',
                  onClick: editRibbon.onClick,
                },
              ],
            },
          ],
        }
      : {}),
  },
});
